const state = {
  isAudioPlay: false,
  isAudioPause: false,
};

const mutations = {
  setAudioPlaying(state, isPlaying) { state.isAudioPlay = isPlaying; },
  setAudioPause(state, isPaused) { state.isAudioPause = isPaused; },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/audio/audio-setting.js